import React, { FC, useMemo } from 'react';
import { PageProps, graphql } from 'gatsby';
import classnames from 'classnames';
import { MainLayout } from '../../templates/MainLayout';
import { t } from '../../i18n';
import { YellowHeader } from '../../components/main/YellowHeader';
import { IHeaderQuery } from '../../queries/headers/types';
import styles from './styles.module.scss';
import DATA from '../../i18n/locales/en';

type IProps = PageProps<IHeaderQuery & any, { locale: string }>;

const PrivacyPolicyPage: FC<IProps> = ({
  location,
  data,
  pageContext: { locale = 'en' },
}) => {
  const header = useMemo(
    () => data.headers.edges.find((edge: any) => edge.node),
    [data.headers]
  );

  const privacyPolicy = useMemo(
    () => data.privacyPolicy.edges.find((edge: any) => edge.node),
    [data.privacyPolicy]
  );

  return (
    <MainLayout
      locale={locale}
      title={DATA.privacy_policy.seo.title}
      description={DATA.privacy_policy.seo.description}
    >
      <YellowHeader header={t('privacy_policy.title')} />
      <div
        className={classnames('content', styles.page)}
        dangerouslySetInnerHTML={{ __html: privacyPolicy?.node?.html || '' }}
      />
    </MainLayout>
  );
};

export const query = graphql`
  {
    headers: allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/privacy-policy/header/header/" } }
    ) {
      ...HeaderFields
    }
    privacyPolicy: allMarkdownRemark(
      filter: {
        fileAbsolutePath: { regex: "/privacy-policy/terms/privacy-policy/" }
      }
    ) {
      ...HeaderFields
    }
  }
`;

export default PrivacyPolicyPage;
